import { createRouter, createWebHistory } from "vue-router";
import { JWTService } from "@/shared/services/jwt.js";
import Login from "../pages/Login/Login.vue";
import ForgotPassword from "../pages/Login/ForgotPassword/ForgotPassword.vue";
import ChangePasswordFirstAccess from "../pages/Login/ChangePasswordFirstAccess/ChangePasswordFirstAccess.vue";


import Dashboard from "../pages/Dashboard/Dashboard.vue";

import ProdutosCliente from "@/pages/Consultas/ProdutosCliente/ProdutosCliente.vue";
import ProdutosEstoque from "@/pages/Consultas/ProdutosEstoque/ProdutosEstoque.vue";
import ProdutosInformacao from "@/pages/Consultas/ProdutosEstoque/ProdutosInformacao.vue";
import VendasPeriodo from "@/pages/Consultas/VendasPeriodo/VendasPeriodo.vue";

import LayoutLogado from "@/Layout/LayoutLogado/LayoutLogado.vue";
import Ajuda from "../pages/Ajuda/Ajuda.vue"

import ReclamacaoTecnicaComercial from "@/pages/Formularios/ReclamacaoTecnicaComercial/ReclamacaoTecnicaComercial.vue";
import ReclamacaoTecnicaComercialFormulario from "@/pages/Formularios/ReclamacaoTecnicaComercial/ReclamacaoTecnicaComercialFormulario.vue";
import ChecklistAmostraLote from "@/pages/Formularios/CheckListAmostraLote/ChecklistAmostraLote.vue";
import ProdutoNovo from "@/pages/Orcamento/ProdutoNovo/ProdutoNovo.vue";
import ProdutoNovoInicio from "@/pages/Orcamento/ProdutoNovo/ProdutoNovoInicio.vue";
import OrcamentoFinal from "@/pages/Orcamento/ProdutoNovo/components/OrcamentoFinal/OrcamentoFinal.vue";
import orcamentoemdigitacao from "@/pages/Orcamento/OrcamentoEmDigitacao/orcamentoemdigitacao.vue";
import OrcamentosLiberados from "@/pages/Orcamento/OrcamentosLiberados/OrcamentosLiberados.vue";
import ConsultarOrcamentoPendentes from '@/pages/Orcamento/ConsultarOrcamentoPendente/ConsultarOrcamentoPendente.vue'
import ConsultarOrcamento from "@/pages/Orcamento/ConsultarOrcamento/ConsultarOrcamento.vue";
import OrcamentoInformacao from "@/pages/Orcamento/ConsultarOrcamento/OrcamentoInformacao.vue";
import OrcamentoPendenteInformacao from "@/pages/Orcamento/ConsultarOrcamentoPendente/OrcamentoPendenteInformacao.vue"
// import OrcamentoLiberados from "@/pages/Orcamento/OrcamentoLiberados/orcamentoLiberados.vue";
import LoteFrete from "@/pages/Orcamento/ProdutoNovo/components/LoteFrete/LoteFrete.vue";
import InfoCliente from "@/pages/Orcamento/ProdutoNovo/components/InfoCliente/InfoCliente.vue";
import InfoBasicas from "@/pages/Orcamento/ProdutoNovo/components/InfoBasicas/InfoBasicas.vue";
import CompProduto from "@/pages/Orcamento/ProdutoNovo/components/CompProduto/CompProduto.vue";
import CaracProduto from "@/pages/Orcamento/ProdutoNovo/components/CaracProduto/CaracProduto.vue";

import ProdutoRepeticao from "@/pages/Orcamento/ProdutoRepeticao/ProdutoRepeticao.vue";
import LoteFreteRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/LoteFreteRepeticao/LoteFreteRepeticao.vue";
import InfoBasicasRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/InfoBasicasRepeticao/InfoBasicasRepeticao.vue";
import ProdutoRepeticaoInicio from "@/pages/Orcamento/ProdutoRepeticao/ProdutoRepeticaoInicio.vue";
import InfoClienteRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/InfoClienteRepeticao/InfoClienteRepeticao.vue";
import CompProdutoRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/CompProdutoRepeticao/CompProdutoRepeticao.vue";
import CaracProdutoRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/CaracProdutoRepeticao/CaracProdutoRepeticao.vue";
import OrcamentoFinalRepeticao from "@/pages/Orcamento/ProdutoRepeticao/components/OrcamentoFinalRepeticao/OrcamentoFinalRepeticao.vue";


import ProdutoRepeticaoAlteracaoInicio from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/ProdutoRepeticaoAlteracaoInicio.vue";
import ProdutoRepeticaoAlteracao from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/ProdutoRepeticaoAlteracao.vue";
import InfoClienteRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/InfoClienteRA/InfoClienteRA.vue";
import LoteFreteRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/LoteFreteRA/LoteFreteRA.vue";
import InfoBasicasRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/InfoBasicasRA/InfoBasicasRA.vue";
import CompProdutoRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/CompProdutoRA/CompProdutoRA.vue";
import CaracProdutoRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/CaracProdutoRA/CaracProdutoRA.vue";
import OrcamentoFinalRA from "@/pages/Orcamento/ProdutoRepeticaoAlteracao/components/OrcamentoFinalRA/OrcamentoFinalRA.vue";



import GerarCartaPropostaFinalizado from "@/pages/CartasProposta/GerarCartaProposta/GerarCartaPropostaFinalizado.vue";
import GerarCartaProposta from "@/pages/CartasProposta/GerarCartaProposta/GerarCartaProposta.vue";
import GerarCartaPropostaOrcamento from "@/pages/CartasProposta/GerarCartaProposta/Componentes/Orcamento/GerarCartaPropostaOrcamento.vue";
import GerarCartaPropostaPagamento from "@/pages/CartasProposta/GerarCartaProposta/Componentes/Pagamento/GerarCartaPropostaPagamento.vue";
import GerarCartaPropostaMarkup from "@/pages/CartasProposta/GerarCartaProposta/Componentes/Markup/GerarCartaPropostaMarkup.vue";
import GerarCartaPropostaInicio from "@/pages/CartasProposta/GerarCartaProposta/GerarCartaPropostaInicio.vue";

import ClienteEmDesenv from "@/pages/Cliente_/ClienteEmDesenv/ClienteEmDesenv.vue";
import ClienteConsulta from "@/pages/Cliente_/ClienteConsulta/ClienteConsulta.vue";
import ClienteInformacoes from "@/pages/Cliente_/ClienteConsulta/Componentes/ClienteInformacoes.vue";
import ClienteFichCada from "@/pages/Cliente_/Cliente/ClienteFichCada.vue";

import GerenciamentoLog from "@/pages/Gerenciamento/GerenciamentoLog/GerenciamentoLog.vue";
import GerenciamentoRepresentante from "@/pages/Gerenciamento/GerenciamentoRepresentante/GerenciamentoRepresentante.vue";
import GerenciamentoTransportadoras from "@/pages/Gerenciamento/GerenciamentoTransportadoras/GerenciamentoTransportadoras.vue";
import GerarNovaTransportadora from "@/pages/Gerenciamento/GerenciamentoTransportadoras/GerarNovaTransportadora/GerarNovaTransportadora.vue";
import GerenciamentoParametros from "@/pages/Gerenciamento/GerenciamentoParametros/GerenciamentoParametros.vue";
import GerenciamentoUsuariosLogados from "@/pages/Gerenciamento/GerenciamentoUsuariosLogados/GerenciamentoUsuariosLogados.vue";
import GerenciamentoUsuarios from "@/pages/Gerenciamento/GerenciamentoUsuarios/GerenciamentoUsuarios.vue";
import GerenciamentoGrupos from "@/pages/Gerenciamento/GerenciamentoGrupos/GerenciamentoGrupos.vue";
import GerenciamentoAcessos from "@/pages/Gerenciamento/Acessos/GerenciamentoAcessos.vue";
import GerenciamentoMenu from "@/pages/Gerenciamento/GerenciamentoMenu/GerenciamentoMenu.vue";
import GerenciamentoCondicoesPagamento from "@/pages/Gerenciamento/GerenciamentoCondicoesPagamento/GerenciamentoCondicoesPagamento.vue";
import GerenciamentoCidades from "@/pages/Gerenciamento/GerenciamentoCidades/GerenciamentoCidades.vue";


import CartaPropostaEmDigitacao from "@/pages/CartasProposta/CartaPropostaEmDigitacao/CartaPropostaEmDigitacao.vue";
import ConsultarCartasProposta from "@/pages/CartasProposta/ConsultarCartasProposta/ConsultarCartasProposta.vue";
import DetalheCartaProposta from "@/pages/CartasProposta/ConsultarCartasProposta/Componentes/DetalheCartaProposta.vue";


import GerarNovoPedidoInicio from "@/pages/Pedidos/GerarNovoPedido/GerarNovoPedidoInicio.vue";
import GerarNovoPedido from "@/pages/Pedidos/GerarNovoPedido/GerarNovoPedido.vue";
import PedidoAguardandoAprovacao from "@/pages/Pedidos/GerarNovoPedido/PedidoAguardandoAprovacao/PedidoAguardandoAprovacao.vue";
import InfoClientePedido from "@/pages/Pedidos/GerarNovoPedido/components/InfoCliente/InfoCliente.vue";
import InfoFrete from "@/pages/Pedidos/GerarNovoPedido/components/InfoFrete/InfoFrete.vue";
import ProdutoCarregamento from "@/pages/Pedidos/GerarNovoPedido/components/ProdutoCarregamento/ProdutoCarregamento.vue";
import CaracProdutoPedido from "@/pages/Pedidos/GerarNovoPedido/components/CaracProduto/CaracProduto.vue";
import PedidoAmostraLote from "@/pages/Pedidos/GerarNovoPedido/components/PedidoAmostraLote/PedidoAmostraLote.vue"
import MeuPerfil from "@/pages/MeuPerfil/MeuPerfil.vue";

import AguardandoAprovacao from "@/pages/CartasProposta/AguardandoAprovacao/AguardandoAprovacao.vue";

import CanceladosLiquidados from "@/pages/Pedidos/CanceladosLiquidados/CanceladosLiquidados.vue";
import DetalhesPedidoEmAndamento from "../pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/DetalhesPedidoEmAndamento.vue";
import ExpedidosFaturados from "@/pages/Pedidos/ExpedidosFaturados/ExpedidosFaturados.vue";
import GerarNovoPedidoOrcamento from "@/pages/Pedidos/GerarNovoPedido/GerarNovoPedidoOrcamento.vue";
import EtiquetaPedidoAguardandoAprovacao from "../pages/Pedidos/PedidoEmAndamento/components/EtiquetaPedidoAguardandoAprovacao/EtiquetaPedidoAguardandoAprovacao.vue";
import HistoricoPedidoEmAndamento from "../pages/Pedidos/PedidoEmAndamento/components/HistoricoPedidoEmAndamento/HistoricoPedidoEmAndamento.vue";
import NotaFiscalPedidoEmAndamento from "../pages/Pedidos/PedidoEmAndamento/components/NotaFiscalPedidoEmAndamento/NotaFiscalPedidoEmAndamento.vue";
import ParcelasPedidoEmAndamento from "../pages/Pedidos/PedidoEmAndamento/components/ParcelasPedidoEmAndamento/ParcelasPedidoEmAndamento.vue";
import ObservacoesPedidoEmAndamento from '../pages/Pedidos/PedidoEmAndamento/components/ObservacoesPedidoEmAndamento/ObservacoesPedidoEmAndamento.vue'
import InstrucoesCarregamentoPedidoEmAndamento from '../pages/Pedidos/PedidoEmAndamento/components/InstrucoesCarregamentoPedidoEmAndamento/InstrucoesCarregamentoPedidoEmAndamento.vue'
import PedidoEmAndamento from "@/pages/Pedidos/PedidoEmAndamento/PedidoEmAndamento.vue";
import PedidoEmAndamentoFluxo from "../pages/Pedidos/PedidoEmAndamento/PedidoEmAndamentoFluxo.vue";
import PedidosCanceladosLiquidadosFluxo from "../pages/Pedidos/CanceladosLiquidados/PedidosCanceladosLiquidadosFluxo.vue";
import DetalhesPedidosCanceladosLiquidados from "../pages/Pedidos/CanceladosLiquidados/DetalhesPedidosCanceladosLiquidados/DetalhesPedidosCanceladosLiquidados.vue";
import HistoricoPedidosCanceladosLiquidados from "../pages/Pedidos/CanceladosLiquidados/HistoricoPedidosCanceladosLiquidados/HistoricoPedidosCanceladosLiquidados.vue";
import NotaFiscalPedidosCanceladosLiquidados from "../pages/Pedidos/CanceladosLiquidados/NotaFiscalPedidosCanceladosLiquidados/NotaFiscalPedidosCanceladosLiquidados.vue";
import ParcelasPedidosCanceladosLiquidados from "../pages/Pedidos/CanceladosLiquidados/ParcelasPedidosCanceladosLiquidados/ParcelasPedidosCanceladosLiquidados.vue";
import PedidoEmDigitacao from "../pages/Pedidos/PedidoEmDigitacao/PedidoEmDigitacao.vue";
import PedidoFinal from "@/pages/Pedidos/GerarNovoPedido/components/PedidoFinal/PedidoFinal.vue";
import ExpedidosFaturadosFluxo from "../pages/Pedidos/ExpedidosFaturados/ExpedidosFaturadosFluxo.vue";
import DetalhesPedidoExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/DetalhesPedidoExpedidoFaturado.vue"
import HistoricoPedidoExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/HistoricoPedidoExpedidoFaturado.vue"
import NotaFiscalPedidoExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/NotaFiscalPedidoExpedidoFaturado.vue";
import ParcelasPedidoExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/ParcelasPedidoExpedidoFaturado.vue"
import DetalhesProdutosCliente from "@/pages/Consultas/ProdutosCliente/Components/DetalhesProdutosCliente.vue";
import ConsultasDevolucoes from "@/pages/Consultas/Devolucoes/ConsultasDevolucoes.vue"
import Comissoes from "@/pages/Consultas/Comissoes/Comissoes.vue";
import NotasFiscais from "@/pages/Consultas/NotasFiscais/NotasFiscais.vue";
import DetalhesNotasFiscais from "@/pages/Consultas/NotasFiscais/Components/DetalhesNotasFiscais.vue";
import ItensNotasFiscais from "@/pages/Consultas/NotasFiscais/Components/ItensNotasFiscais.vue";
import DetalhesTitulo from "@/pages/Consultas/Titulos/components/DetalhesTitulo.vue";
import Titulos from "@/pages/Consultas/Titulos/Titulos.vue";
import InstrucoesCarregamentoPedidoCanceladosLiquidados from "@/pages/Pedidos/CanceladosLiquidados/InstrucoesCarregamentoPedidoCanceladosLiquidados/InstrucoesCarregamentoPedidoCanceladosLiquidados.vue";
import ObservacoesPedidosCanceladosLiquidados from "@/pages/Pedidos/CanceladosLiquidados/ObservacoesPedidosCanceladosLiquidados/ObservacoesPedidosCanceladosLiquidados.vue";
import ObservacoesPedidosExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/ObservacoesPedidosExpedidoFaturado.vue";
import InstrucoesCarregamentoPedidosExpedidoFaturado from "@/pages/Pedidos/ExpedidosFaturados/components/InstrucoesCarregamentoPedidosExpedidoFaturado.vue";
import DetalhesReclamacaoTecnica from "@/pages/Formularios/ReclamacaoTecnicaComercial/components/DetalhesReclamacaoTecnica.vue";
import RascunhoCartaProposta from "@/pages/CartasProposta/ConsultarCartasProposta/Componentes/RascunhoCartaProposta.vue";
import GerenciamentoComissoes from "@/pages/Gerenciamento/GerenciamentoComissoes/GerenciamentoComissoes.vue";
import CadastroUsuario from "@/pages/Gerenciamento/GerenciamentoUsuarios/CadastroUsuario.vue";
import ResumoSequencia from "@/pages/Pedidos/GerarNovoPedido/components/ResumoSequencia/ResumoSequencia.vue"
import AdicionarGrupo from "@/pages/Gerenciamento/GerenciamentoGrupos/AdicionarGrupo/AdicionarGrupo.vue";
import GerenciamentoImpostos from "@/pages/Gerenciamento/GerenciamentoImpostos/GerenciamentoImpostos.vue";
import SemAcesso from "@/pages/SemAcesso/SemAcesso.vue"; 
import SSO from "@/pages/Login/SSO/SSO.vue";
import Tapume from "@/pages/Login/Tapume/Tapume.vue";
import GerenciamentoAutomacao from "@/pages/Gerenciamento/GerenciamentoAutomacao/GerenciamentoAutomacao.vue";


const assertLoggedIn = (to, from, next) => {
  if (!JWTService.GetToken()) {
    next({ name: 'Login' })
  } else next()
}

const routes = [
  {
    path: "/ForgotPassword/",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      hasAuth: false,
    },
  },
  {
    path: "/ChangePasswordFirstAccess/:id",
    name: "ChangePasswordFirstAccess",
    component: ChangePasswordFirstAccess,
    meta: {
      hasAuth: false,
    },
  },
  {
    path: "/Tapume",
    name: "Tapume",
    component: Tapume,
    meta: {
      hasAuth: false,
    },
  },
  {
    path: "/SSO",
    name: "SSO",
    component: SSO,
    meta: {
      hasAuth: false,
    },
  },
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: '/layout',
    name: "LayoutLogado",
    component: LayoutLogado,
    beforeEnter: assertLoggedIn,
    children: [
      {
        path: '/sem-acesso',
        name: 'SemAcesso',
        component: SemAcesso
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: '/meu-perfil',
        name: 'MeuPerfil',
        component: MeuPerfil
      },
      {
        path: "/produtos-cliente/",
        name: "ProdutosCliente",
        component: ProdutosCliente,
      },
      {
        path: "/produtos-cliente-detalhes/:id",
        name: "DetalhesProdutosCliente",
        component: DetalhesProdutosCliente,
      },
      {
        path: "/devolucoes/",
        name: "ConsultasDevolucoes",
        component: ConsultasDevolucoes,
      },
      {
        path: "/orcamento-em-digitacao/",
        name: "EmDigitacao",
        component: orcamentoemdigitacao,
      },
      {
        path: "/orcamentos-liberados/:FlagDashboard?",
        name: "Liberados",
        component: OrcamentosLiberados,
      },
      {
        path: "/produtos-estoque",
        name: "ProdutosEstoque",
        component: ProdutosEstoque,
      },
      {
        path: "/produtos-informacao/:id/:numeroParcela",
        name: "ProdutosInformacao",
        component: ProdutosInformacao,
        },

      {
        path: "/vendas-por-periodo",
        name: "VendasPeriodo",
        component: VendasPeriodo
      },

      {
        path: "/comissoes",
        name: "Comissoes",
        component: Comissoes
      },

      {
        path: "/notas-fiscais/:codigoPedido?/:numeroParcela?",
        name: "NotasFiscais",
        component: NotasFiscais,
      },

      {
        path: "/notas-fiscais-detalhes/:id",
        name: "DetalhesNotasFiscais",
        component: DetalhesNotasFiscais,
      },

      {
        path: "/notas-fiscais-itens/:id",
        name: "ItensNotasFiscais",
        component: ItensNotasFiscais,
      },

      {
        path: "/ficha-cadastro",
        name: "ClienteFichCada",
        component: ClienteFichCada,
      },
      {
        path: "/ficha-cadastro/:id",
        name: "ClienteFichCadaId",
        component: ClienteFichCada,
      },
      {
        path: "/Ajuda",
        name: "Ajuda",
        component: Ajuda,
      },
      {
        path: "/cliente-em-desenvolvimento/:id",
        name: "ClienteEmDesenvId",
        component: ClienteEmDesenv,
      },
      {
        path: "/cliente-em-desenvolvimento",
        name: "ClienteEmDesenv",
        component: ClienteEmDesenv,
      },
      {
        path: "/cliente-consulta",
        name: "ClienteConsulta",
        component: ClienteConsulta,
      },
      {
        path: "/cliente-informacao/:id/:unidadeId",
        name: "ClienteInformacoes",
        component: ClienteInformacoes,
      },

      {
        path: "/gerenciamento-usuarios-geral",
        name: "GerenciamentoUsuarios",
        component: GerenciamentoUsuarios,
      },
      {
        path: "/gerenciamento-cidades-tipo-frete",
        name: "GerenciamentoCidades",
        component: GerenciamentoCidades,
      },
      {
        path: "/gerenciamento-grupos",
        name: "GerenciamentoGrupos",
        component: GerenciamentoGrupos,
      },
      {
        path: "/adicionar-grupo/:id?",
        name: "AdicionarGrupo",
        component: AdicionarGrupo,
      },
      {
        path: "/gerenciamento-acessos",
        name: "GerenciamentoAcessos",
        component: GerenciamentoAcessos,
      },
      {
        path: "/gerenciamento-menu",
        name: "GerenciamentoMenu",
        component: GerenciamentoMenu,
      },
      {
        path: "/gerenciamento-log",
        name: "GerenciamentoLog",
        component: GerenciamentoLog,
      },
      {
        path: "/gerenciamento-parametros",
        name: "GerenciamentoParametros",
        component: GerenciamentoParametros,
      },
      {
        path: "/gerenciamento-usuarios-logados",
        name: "GerenciamentoUsuariosLogados",
        component: GerenciamentoUsuariosLogados,
      },
      {
        path: "/gerenciamento-condicoes-pagamento",
        name: "GerenciamentoCondicoesPagamento",
        component: GerenciamentoCondicoesPagamento,
      },
      {
        path: "/gerenciamento-impostos",
        name: "GerenciamentoImpostos",
        component: GerenciamentoImpostos,
      },
      {
        path: "/produto-novo-inicio",
        name: "ProdutoNovoInicio",
        component: ProdutoNovoInicio,
      },
      {
        path: "/produto-repeticao-alteracao-inicio",
        name: "ProdutoRepeticaoAlteracaoInicio",
        component: ProdutoRepeticaoAlteracaoInicio,
      },
      {
        path: "/produto-repeticao-alteracao/:id",
        name: "ProdutoRepeticaoAlteracao",
        component: ProdutoRepeticaoAlteracao,
        children: [
          {
            path: "info-cliente-ra",
            name: "InfoClienteRA",
            component: InfoClienteRA
          },
          {
            path: "lote-frete-ra",
            name: "LoteFreteRA",
            component: LoteFreteRA
          },
          {
            path: "info-basicas-ra",
            name: "InfoBasicasRA",
            component: InfoBasicasRA
          },
          {
            path: "componentes-produto-ra",
            name: "CompProdutoRA",
            component: CompProdutoRA
          },
          {
            path: "caracteristicas-produto-ra",
            name: "CaracProdutoRA",
            component: CaracProdutoRA
          }
        ]
      },
      {
        path: "/orcamento-final-ra/:id",
        name: "OrcamentoFinalRA",
        component: OrcamentoFinalRA,
      },

      {
        path: "/gerar-carta-proposta/:id",
        name: "GerarCartaProposta",
        component: GerarCartaProposta,
        children: [
          {
            path: "orcamento",
            name: "GerarCartaPropostaOrcamento",
            component: GerarCartaPropostaOrcamento
          },
          {
            path: "pagamento",
            name: "GerarCartaPropostaPagamento",
            component: GerarCartaPropostaPagamento
          },
          {
            path: "markup",
            name: "GerarCartaPropostaMarkup",
            component: GerarCartaPropostaMarkup
          },
        ]
      },
      {
        path: "/gerar-carta-proposta-inicio",
        name: "GerarCartaPropostaInicio",
        component: GerarCartaPropostaInicio,
      },
      {
        path: "/gerar-carta-proposta-finalizado/:id",
        name: "GerarCartaPropostaFinalizado",
        component: GerarCartaPropostaFinalizado,
      },
      {
        path: "/carta-proposta-rascunho/:id",
        name: "CartaPropostaRascunho",
        component: RascunhoCartaProposta,
      },
      {
        path: "/carta-proposta-em-digitacao/",
        name: "CartaPropostaEmDigitacao",
        component: CartaPropostaEmDigitacao,
      },
      {
        path: "/consultar-cartas-proposta/",
        name: "ConsultarCartasProposta",
        component: ConsultarCartasProposta,
      },

      {
        path: "/carta-proposta-detalhes/:id",
        name: "DetalheCartaProposta",
        component: DetalheCartaProposta,
      },
      {
        path: "/cartas-proposta-aguardando-aprovacao/",
        name: "CartasPropostaAguardandoAprovacao",
        component: AguardandoAprovacao,
      },
      {
        path: "/produto-novo/:id",
        name: "ProdutoNovo",
        component: ProdutoNovo,
        children: [
          {
            path: "infos-cliente",
            name: "InfoCliente",
            component: InfoCliente
          },
          {
            path: "lote-frete",
            name: "LoteFrete",
            component: LoteFrete
          },
          {
            path: "info-basicas",
            name: "InfoBasicas",
            component: InfoBasicas
          },
          {
            path: "componentes-produto",
            name: "CompProduto",
            component: CompProduto
          },
          {
            path: "caracteristicas-produto",
            name: "CaracProduto",
            component: CaracProduto
          }
        ]
      },
      {
        path: "/orcamento-final/:id",
        name: "OrcamentoFinal",
        component: OrcamentoFinal,
      },
      {
        path: "/consultar-orcamento/:FlagDashboard?",
        name: "ConsultarOrcamento",
        component: ConsultarOrcamento,
      },
      {
        path: "/orcamentos-pendentes/:FlagDashboard?",
        name: "ConsultarOrcamentoPendente",
        component: ConsultarOrcamentoPendentes,
      },
      {
        path: "/orcamentos-pendentes-informacao/:id",
        name: "OrcamentoPendenteInformacao",
        component: OrcamentoPendenteInformacao
      },
      {
        path: "/orcamento-informacao/:id",
        name: "OrcamentoInformacao",
        component: OrcamentoInformacao,
      },
      // {
      //   path: "/orcamento-liberado",
      //   name: "OrcamentoLiberados",
      //   component: OrcamentoLiberados,
      // },
      {
        path: "/produto-repeticao/:id",
        name: "ProdutoRepeticao",
        component: ProdutoRepeticao,
        children: [
          {
            path: "Informacao-Cliente-Repeticao",
            name: "InfoClienteRepeticao",
            component: InfoClienteRepeticao
          },
          {
            path: "Lote-Frete-Repeticao",
            name: "LoteFreteRepeticao",
            component: LoteFreteRepeticao
          },
          {
            path: "info-basicas-repeticao",
            name: "InfoBasicasRepeticao",
            component: InfoBasicasRepeticao
          },
          {
            path: "componentes-produto-repeticao",
            name: "CompProdutoRepeticao",
            component: CompProdutoRepeticao
          },
          {
            path: "caracteristicas-produto-repeticao",
            name: "CaracProdutoRepeticao",
            component: CaracProdutoRepeticao
          },
        ]
      },
      {
        path: "/orcamento-final-repeticao/:id",
        name: "OrcamentoFinalRepeticao",
        component: OrcamentoFinalRepeticao,
      },
      {
        path: "/reclamacao-tecnica-comercial/",
        name: "ReclamacaoTecnicaComercial",
        component: ReclamacaoTecnicaComercial,
      },
      {
        path: "/detalhes-reclamacao-tecnica/:id",
        name: "DetalhesReclamacaoTecnica",
        component: DetalhesReclamacaoTecnica,
      },
      {
        path: "/formulario/:idcliente/:idempresa/:idrepresentante",
        name: "ReclamacaoTecnicaComercialFormulario",
        component: ReclamacaoTecnicaComercialFormulario
      },
      {
        path: "/checklist-amostra-lote/",
        name: "ChecklistAmostraLote",
        component: ChecklistAmostraLote,
      },
      {
        path: "/produto-repeticao-inicio",
        name: "ProdutoRepeticaoInicio",
        component: ProdutoRepeticaoInicio,
      },
      {
        path: "/gerenciamento-representante",
        name: "GerenciamentoRepresentante",
        component: GerenciamentoRepresentante,
      },
      {
        path: "/gerenciamento-transportadoras",
        name: "GerenciamentoTransportadoras",
        component: GerenciamentoTransportadoras,
      },
      {
        path: "/gerenciamento-automacao",
        name: "GerenciamentoAutomacao",
        component: GerenciamentoAutomacao,
      },
      {
        path: "/gerar-nova-transportadora",
        name: "GerarNovaTransportadora",
        component: GerarNovaTransportadora,
      },
      {
        path: "/gerenciamento-log",
        name: "GerenciamentoLog",
        component: GerenciamentoLog,
      },
      {
        path: "/gerenciamento-comissoes",
        name: "GerenciamentoComissoes",
        component: GerenciamentoComissoes,
      },
      {
        path: "/orcamento-final-repeticao/:id",
        name: "OrcamentoFinalRepeticao",
        component: OrcamentoFinalRepeticao,
      },
      {
        path: "/gerar-novo-pedido-orcamento",
        name: "GerarNovoPedidoOrcamento",
        component: GerarNovoPedidoOrcamento
      },
      {
        path: "/gerar-novo-pedido-inicio",
        name: "GerarNovoPedidoInicio",
        component: GerarNovoPedidoInicio,
      },
      {
        path: "/gerar-novo-pedido/:id",
        name: "GerarNovoPedido",
        component: GerarNovoPedido,
        children: [
          {
            path: "info-cliente-pedido",
            name: "InfoClientePedido",
            component: InfoClientePedido
          },
          {
            path: "info-frete-pedido",
            name: "InfoFrete",
            component: InfoFrete
          },
          {
            path: "produto-em-carregamento-pedido",
            name: "ProdutoCarregamento",
            component: ProdutoCarregamento
          },
          {
            path: "carac-produto-pedido",
            name: "CaracProdutoPedido",
            component: CaracProdutoPedido
          },
          {
            path: "pedido-amostra-lote",
            name: "PedidoAmostraLote",
            component : PedidoAmostraLote
          }
        ]
      },
      {
        path: "/resumo-sequencia/:id",
        name: "ResumoSequencia",
        component : ResumoSequencia
      },
      {
        path: "/pedido-em-digitacao",
        name: "PedidoEmDigitacao",
        component: PedidoEmDigitacao
      },

      {
        path: "/andamento-de-pedidos/:FlagDashboard?",
        name: "PedidoAguardandoAprovacao",
        component: PedidoAguardandoAprovacao,
      },

      {
        path: "/pedido-final/:id",
        name: "PedidoFinal",
        component: PedidoFinal
      },

      {
        path: "/pedido-cancelado-liquidado",
        name: "PedidosCanceladosLiquidados",
        component: CanceladosLiquidados,
      },
      {
        path: "/pedido-cancelado-liquidado-fluxo/:id",
        name: "PedidosCanceladosLiquidadosFluxo",
        component: PedidosCanceladosLiquidadosFluxo,
        children: [
          {
            path: "detalhes-pedido-cancelado-liquidado",
            name: "DetalhesPedidosCanceladosLiquidados",
            component: DetalhesPedidosCanceladosLiquidados
          },
          {
            path: ":numeroParcela/historico-pedido-cancelado-liquidado",
            name: "HistoricoPedidosCanceladosLiquidados",
            component: HistoricoPedidosCanceladosLiquidados
          },
          {
            path: "nota-fiscal-pedido-cancelado-liquidado",
            name: "NotaFiscalPedidosCanceladosLiquidados",
            component: NotaFiscalPedidosCanceladosLiquidados
          },
          {
            path: "parcelas-pedido-cancelado-liquidado",
            name: "ParcelasPedidosCanceladosLiquidados",
            component: ParcelasPedidosCanceladosLiquidados
          },
          {
            path: ":numeroParcela/instrucoes-carregamento-pedido-cancelado-liquidado",
            name: "InstrucoesCarregamentoPedidoCanceladosLiquidados",
            component: InstrucoesCarregamentoPedidoCanceladosLiquidados
          },
          {
            path: ":numeroParcela/observacoes-pedido-cancelado-liquidado",
            name: "ObservacoesPedidosCanceladosLiquidados",
            component: ObservacoesPedidosCanceladosLiquidados
          },
        ]
      },
      {
        path: "/gerar-novo-pedido-orcamento",
        name: "GerarNovoPedidoOrcamento",
        component: GerarNovoPedidoOrcamento
      },

      {
        path: "/pedido-expedido-faturado",
        name: "ExpedidosFaturados",
        component: ExpedidosFaturados,
      },
      {
        path: "/pedido-expedido-faturado-fluxo/:id",
        name: "ExpedidosFaturadosFluxo",
        component: ExpedidosFaturadosFluxo,
        children: [
          {
            path: "detalhes-pedido-expedido-faturado",
            name: "DetalhesPedidoExpedidoFaturado",
            component: DetalhesPedidoExpedidoFaturado
          },
          {
            path: ":numeroParcela/historico-pedido-expedido-faturado",
            name: "HistoricoPedidoExpedidoFaturado",
            component: HistoricoPedidoExpedidoFaturado
          },
          {
            path: "notaFiscal-pedido-expedido-faturado",
            name: "NotaFiscalPedidoExpedidoFaturado",
            component: NotaFiscalPedidoExpedidoFaturado
          },
          {
            path: "parcelas-pedido-expedido-faturado",
            name: "ParcelasPedidoExpedidoFaturado",
            component: ParcelasPedidoExpedidoFaturado
          },
          {
            path: ":numeroParcela/instrucoes-carregamento-pedido-expedido-faturado",
            name: "InstrucoesCarregamentoPedidosExpedidoFaturado",
            component: InstrucoesCarregamentoPedidosExpedidoFaturado
          },
          {
            path: ":numeroParcela/observacoes-pedido-expedido-faturado",
            name: "ObservacoesPedidosExpedidoFaturado",
            component: ObservacoesPedidosExpedidoFaturado
          },
        ]
      },

      {
        path: "/pedido-em-fase-digitacao",
        name: "PedidoEmAndamento",
        component: PedidoEmAndamento
      },
      {
        path: "/cadastro-usuario/:id?",
        name: "CadastroUsuario",
        component: CadastroUsuario,
      },

      {
        path: "/pedido-em-andamento-fluxo/:id",
        name: "PedidoEmAndamentoFluxo",
        component: PedidoEmAndamentoFluxo,
        children: [
          {
            path: "detalhes-pedido-andamento",
            name: "DetalhesPedidoEmAndamento",
            component: DetalhesPedidoEmAndamento
          },
          {
            path: ":numeroParcela/historico-pedido-andamento",
            name: "HistoricoPedidoEmAndamento",
            component: HistoricoPedidoEmAndamento
          },
          {
            path: "nota-fiscal-pedido-andamento",
            name: "NotaFiscalPedidoEmAndamento",
            component: NotaFiscalPedidoEmAndamento
          },
          {
            path: "parcelas-pedido-andamento",
            name: "ParcelasPedidoEmAndamento",
            component: ParcelasPedidoEmAndamento
          },
          {
            path: ":numeroParcela/observacoes-pedido-andamento",
            name: "ObservacoesPedidoEmAndamento",
            component: ObservacoesPedidoEmAndamento
          },
          {
            path: ":numeroParcela/instrucoes-carregamento-pedido-andamento",
            name: "InstrucoesCarregamentoPedidoEmAndamento",
            component: InstrucoesCarregamentoPedidoEmAndamento
          },
          {
            path: "etiqueta-pedido-aguardando-aprovacao",
            name: "EtiquetaPedidoAguardandoAprovacao",
            component: EtiquetaPedidoAguardandoAprovacao
          },
        ]
      },
      {
        path: "/titulos/:codigoExternoNF?",
        name: "Titulos",
        component: Titulos,
      },
      {
        path: "/detalhes-titulo/:id",
        name: "DetalhesTitulo",
        component: DetalhesTitulo,
      },

    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router
